<!-- eslint-disable vue/no-static-inline-styles -->
<template>
  <form
    :id="`${layout}-ometria-form-signup`"
    ref="container"
    class="newsletter"
    :class="[
      $blockClass(blockClass, 'newsletter'),
    ]"
    action="https://api.ometria.com/forms/signup"
    method="post"
    @submit.prevent="(event) => handleSubmit(event)"
  >
    <input
      type="hidden"
      name="__form_id"
      :value="newsletterFormId"
    >
    <input
      type="hidden"
      name="email"
      value=""
      autocomplete="off"
    >
    <input
      class="is-hidden"
      name="__email"
      type="email"
      value=""
      autocomplete="off"
    >

    <input
      name="@account"
      type="hidden"
      :value="accountId"
    >
    <input
      name="@add_to_lists[]"
      type="hidden"
      :value="newsletterListId"
    >
    <input
      name="@subscription_status"
      type="hidden"
      value="SUBSCRIBED"
    >
    <input
      name="sign_up_source"
      type="hidden"
      value="Pop-up"
    >
    <input
      v-if="countryCode !== ''"
      name="country_id"
      type="hidden"
      :value="countryCode"
    >
    <fieldset v-if="successMessage === '' && show">
      <div

        class="form-group"
        :class="[
          $blockClass(blockClass, 'form-group'),
        ]"
      >
        <div
          class="form-group__field form-group__input--block"
          :class="[
            $blockClass(blockClass, 'field'),
            { [$class('active')]: focus },
          ]"
        >
          <label
            class="form-group__label"
            :htmlFor="`${layout}-newsletter-input`"
            style="color:var(--color-toteme-black-primary) !important;"
            v-text="$string('customers.fields.email.label')"
          />

          <input
            :id="`${layout}-newsletter-email`"
            v-model.trim="formData.email"
            class="form-group__input"
            :placeholder="$string('customers.fields.email.label')"
            js-input-button="true"
            type="email"
            name="ue"
            autocomplete="off"
            required
            @focus="focus = true"
            @blur="formData.email.length === 0 ? focus = false : focus = true"
          >
        </div>
      </div>

      <div
        class="checkbox"
        :class="[
          $blockClass(blockClass, 'checkbox'),
          $class('hidden'),
        ]"
      >
        <input
          :id="`${layout}-newsletter-confirm`"
          class="checkbox__input"
          type="hidden"
          name="acceptsEmail"
          value="true"
        >
        <label
          class="checkbox__label"
          :htmlFor="`${layout}-newsletter-confirm`"
          v-text="$string('general.site_footer.newsletter_confirm')"
        />
      </div>
    </fieldset>
    <!-- success message -->
    <p
      v-if="successMessage !== ''"
      class="newsletter-popup__success-message"
      v-text="successMessage"
    />

    <template v-if="formState === 'success'">
      <btn
        class="button newsletter-popup__submit-btn button--block button-success"
        type="button"
        :class="{
          [$class('disabled')]: !validEmail || formState === 'submitting',
          ['button-success']: formState === 'success',
        }"
        :label="computedButtonLabel"
        :aria-disabled="!validEmail || formState === 'submitting'"
        :show-text-icon="false"
        :disabled="!validEmail || formState === 'submitting'"
        @click="handleContinueShopping"
      />
    </template>

    <btn
      v-else-if="!show"
      class="button newsletter-popup__submit-btn button--block"
      type="button"
      :label="$string('general.site_footer.newsletter_button')"
      :aria-disabled="formState === 'submitting'"
      :aria-hidden="formState === 'success'"
      :show-text-icon="false"
      @click="show = true"
    />

    <btn
      v-else
      class="button newsletter-popup__submit-btn button--block"
      type="submit"
      :class="{
        [$class('disabled')]: !validEmail || formState === 'submitting',
        ['button-success']: formState === 'success',
      }"
      :label="computedButtonLabel"
      :aria-disabled="!validEmail || formState === 'submitting'"
      :show-text-icon="false"
      :disabled="!validEmail || formState === 'submitting'"
      @click="handleContinueShopping"
    />
  </form>
</template>

<script>

/**
 * Vue: Newsletter Field
 * -----------------------------------------------------------------------------
 * Newsletter input field for footer.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {String} [layout] - Layout to render newsletter field.
 *
 */
import Btn from '~global/btn/btn'
import FormFields from '~/components/form-fields'
import Cookies from 'js-cookie'

export default {
  name: 'NewsletterForm',

  components: {
    Btn,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'desktop',
    },
  },

  emits: {
    'newsletter-submitted': () => true,
  },

  data() {
    return {
      accountId: '',
      formState: 'pending',
      formData: {
        email: '',
      },
      newsletterFormId: '',
      newsletterListId: '',
      ometriaInitialized: false,
      show: false,
      focus: false,
      successMessage: '',
      returnUrl: window.location.href,
      countryCode: '',
    }
  },

  computed: {

    /**
     * Computes a label based on form state.
     * @returns {String}
     */
    inputLabel() {
      return this.$string('general.site_footer.newsletter_input')
    },

    /**
     * Computes a label based on form state.
     * @returns {String}
     */
    buttonLabel() {
      return this.formState === 'submitting'
        ? this.$string('general.site_footer.newsletter_submitting')
        : this.$string('general.site_footer.newsletter_submit')
    },

    // /**
    //  * Valid email address.
    //  * @returns {Boolean}
    //  */
    validEmail() {
      // Valid email address.
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(this.formData.email)
    },

    computedButtonLabel() {
      return this.successMessage === '' ? this.$string('general.site_footer.newsletter_button') : this.$string('cart.continue_shopping')
    },
  },

  mounted() {
    this.getOmetriaDetails()
    this.getNewsletterForm()
    FormFields().init()

    this.$nextTick().then(() => {
      this.countryCode = window?.Shopify.country
    })
  },

  methods: {

    handleContinueShopping() {
      if (this.successMessage) {
        this.$emit('newsletter-submitted', true)
      }
      if (this.successMessage !== '') {
        this.$emit('newsletter-submitted')
      }
    },

    /**
     * Gets global ometria details
     */
    getOmetriaDetails() {
      if (!cnvs.ometria) {
        return
      }

      this.accountId = cnvs.ometria?.accountId
      this.newsletterListId = cnvs.ometria?.newsletterListId
      this.newsletterFormId = cnvs.ometria?.newsletterFormId
    },

    /**
     * Handles initialization of Ometria AJAX.
     */
    checkOmetriaAjaxInit() {
      if (this.ometriaInitialized) {
        return
      }

      this.getNewsletterForm()
    },

    /**
     * Gets the ID of the form to use in the Ometria ajax function.
     * The function is defined in Ometria's script.
     */
    getNewsletterForm() {
      const formId = this.$refs.container?.getAttribute('id')
      const formIdSelector = `#${formId}`

      if (window.ometria && typeof window.ometria.ajaxFormSubmit === 'function') {
        window.ometria.ajaxFormSubmit(
          formIdSelector,
          this.handleSubmitResponse,
        )
        this.ometriaInitialized = true
      }
    },

    /**
     * Submits the form to Ometria Coming Soon list.
     */
    handleSubmit(event) {
      this.formState = 'submitting'
      this.checkOmetriaAjaxInit()
      if (!this.$refs.container) {
        return
      }

      const formElements = event.target.elements

      const urlEncodedDataPairs = Object.keys(formElements)

        .map((key) => {
          return `${encodeURIComponent(formElements[key].name)}=${encodeURIComponent(formElements[key].value)}`
        })

      let formBody = []

      formBody = urlEncodedDataPairs.join('&').replace(/%20/g, '+')

      fetch('https://api.ometria.com/forms/signup/ajax', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      }).then((response) => {
        if (response.ok) {
          this.updateFormMessage(this.$string('general.site_footer.newsletter_success'), 'success')
          Cookies.set('newsletter_modal', 'dismissed', { expires: 30 })
          Cookies.set('newsletter_page_counter', '0')
        }
      }).catch(() => {
        this.updateFormMessage(this.$string('general.site_footer.newsletter_error'), 'error')
      })
    },

    /**
     * Handles updating the messages displayed in the form.
     * @param {String} message - Message to be displayed.
     * @param {String} state - Whether the message is a success or an error.
     */
    updateFormMessage(message, state) {
      this.successMessage = message

      if (state !== 'success') {
        this.formState = {
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
        }
        return
      }
      this.formState = 'success'
      this.$emit('newsletter-submitted', false)
    },
  },
}
</script>

<style lang="scss">
@import './newsletter-form';
</style>
